import type WillBlurTextInputOnTapOutside from './types';

const willBlurTextInputOnTapOutside: WillBlurTextInputOnTapOutside = () => true;

export default willBlurTextInputOnTapOutside;
